import React, { Component } from 'react';
import _ from 'lodash';
import { ExpandableTable } from '../../../../components';
import { getDmService } from '../../../../services/Api';

const FILTERS_DATA = [
  { id: '', label: 'Todos' },
  { id: '6', label: 'Aprovado' },
  { id: '5', label: 'Cancelado' },
  { id: '4', label: 'Devolvido' },
  { id: '3', label: 'Pendente' },
  { id: '7', label: 'Programado' },
  { id: '8', label: 'Enviado' },
];

class Items extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      items: {},
      search: '',
      status: FILTERS_DATA[0],
      page: 1,
      pageSize: 100,
      totalItems: 0,
      orderBy: '',
      orderDirection: '',
    };
  }

  componentDidMount() {
    this.getItems();
  }

  getItems = async () => {
    const { items, status, page, pageSize, search, orderDirection, orderBy } = this.state;
    const { filters } = this.props;

    this.setState({ isLoading: _.isEmpty(items) });
    const _order =
      (orderBy ? `&ordem=${orderBy}` : '') +
      (orderDirection ? `&ordemDirecao=${orderDirection}` : '');
    getDmService(
      `/Pedido/GetCampanhaMensagemAssistente?busca=${search}&pageNumber=${page}&pageSize=${pageSize}&status=${
        status.id
      }&${filters}${_order}`,
    )
      .then(data => {
        this.setState({ items: data, isLoading: false, totalItems: data.totalCount });
      })
      .catch(() => {
        this.setState({ isLoading: false });
      });
  };

  onPaginationChange = obj => {
    this.setState({ page: obj.page, pageSize: obj.pageSize }, () => {
      this.getItems();
    });
  };

  onFilterChange = obj => {
    this.setState({ status: obj.selectedItem, page: 1 }, () => {
      this.getItems();
    });
  };

  getItemsDebounced = _.debounce(this.getItems, 500);

  onSearchChange = event => {
    this.setState({ search: event.target.value, page: 1 }, () => {
      this.getItemsDebounced();
    });
  };

  handleSort = (key, direction) => {
    this.setState(
      {
        orderBy: key,
        orderDirection: direction,
        page: 1,
      },
      () => {
        this.getItems();
      },
    );
  };

  clickRow = id => {
    const { history } = this.props;
    localStorage.setItem('urlReturn', history.location.pathname);
    history.push(`/admin/comunicacao/campanha/${id}/detalhe`);
  };

  render() {
    const { isLoading, items, page, pageSize, totalItems, status, search } = this.state;

    return (
      <ExpandableTable
        isLoading={isLoading}
        rowsData={items.resultado}
        headersData={items.header}
        filters={FILTERS_DATA}
        onSearchChange={this.onSearchChange}
        onFilterChange={this.onFilterChange}
        onPaginationChange={this.onPaginationChange}
        onClickRow={({ id }) => this.clickRow(id)}
        handleSort={this.handleSort}
        page={page}
        pageSize={pageSize}
        totalItems={totalItems}
        defaultFilter={status}
        search={search}
      />
    );
  }
}

export default Items;



// WEBPACK FOOTER //
// ./src/screens/admin/MessagesCampaigns/List/Items.js